import { render, staticRenderFns } from "./CustomerTags.vue?vue&type=template&id=11127aac&"
import script from "./CustomerTags.vue?vue&type=script&lang=js&"
export * from "./CustomerTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports